<template>
    <div class="dropdown d-flex" :class="{'dropdown-shadow': isOpen}">
        <div class="c-select d-inline-flex gap-2 flex-grow-1" @click="toggleDropdown">
            <div class="text-truncate">
                <slot name="selected" :value="value">
                    {{ getTitle(value) }}
                </slot>
            </div>

            <div class="ml-auto pe-none">
                <img :srcset="$getImg2('/icons/caret-down-icon@1x.png', '/icons/caret-down-icon@2x.png')">
            </div>
        </div>

        <div class="options dropdown-shadow" v-if="isOpen">
            <slot name="options" :selectOption="selectOption">
                <div v-for="option in options" :key="option" @click="selectOption(option)">
                    {{ getTitle(option) }}
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['options', 'value', 'trans'],
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.closeOnOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeOnOutsideClick);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option) {
            this.isOpen = false;
            this.$emit('input', option);
        },
        closeOnOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isOpen = false;
            }
        },
        getTitle(option) {
            if (this.trans) {
                return this.$trans(`${this.trans}.${option}`);
            }

            return option;
        }
    }
};
</script>

<style lang="scss" scoped>
.dropdown {
    border: none;
    width: 100%;
    position: relative;
    cursor: pointer;
    user-select: none;
}

.c-select {
    padding: 9px;
    background: white;

    font-size: 14px;
    font-weight: 500;
}

.options {
    background-color: white;
    border-top: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 100;

    max-height: 300px;
    overflow: auto;

    & > * {
        padding: 8px;
        background-color: #fff;

        &:hover {
            background-color: #f6f6f6;
        }
    }
}

.dropdown-shadow {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
}
</style>
